import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useAppSelector } from '../../../../services/store';
import { getSelectedCategoriesFilter, getSelectedPostTypeFilter } from 'src/shared/redux-state/src';
import { CustomButton, CustomCheckbox } from 'src/app/components';
import { EyengageFilterCategory } from 'src/shared/types/src';
import EyengagePostCategoryListModal from 'src/app/components/modals/EyengagePostCategoryListModal';
import { IoCloseOutline } from "react-icons/io5";
import { FaCaretDown } from "react-icons/fa";
import { ACTIVITY_TYPE } from "src/shared/config/src";

const filterByTypeData = [
  {
    name: 'All',
    id: 'ALL',
  },
  {
    name: 'Events',
    id: 'EVENT',
  },
  {
    name: 'Posts',
    id: 'POSTS',
  },
  {
    name: 'Polls',
    id: 'POLL',
  },
  {
    name: 'Posts with Confirmation',
    id: 'CONFIRMATION_POSTS',
  },
];

const filterByTypeDataIds = {
  ALL: 'ALL',
  [ACTIVITY_TYPE.EVENT]: 'EVENT',
  [ACTIVITY_TYPE.POSTS]: 'POSTS',
  [ACTIVITY_TYPE.POLL]: 'POLL',
  [ACTIVITY_TYPE.CONFIRMATION_POSTS]: 'CONFIRMATION_POSTS',
}

type EngageFilterHeaderProps = {
  postFilterType: Array<string>
  postFilterCategories: EyengageFilterCategory[]
  saveFilterTypeSelection: (types: string[]) => void;
  saveFilterTypeCategories: (category: EyengageFilterCategory[]) => void,
};

const EngageFilterBody: React.FC<EngageFilterHeaderProps> = ({ postFilterType, postFilterCategories, saveFilterTypeSelection, saveFilterTypeCategories }) => {

  const [categoryModal, setCategoryModal] = useState<boolean>(false);

  const handleItemPress = (item: any) => {
    // const currItemId = postFilterType.find((id: string) => id === item?.id);
    // let filteredRes: string[] = [];
    // if (currItemId) {
    //   filteredRes = postFilterType.filter((id: string) => id !== item?.id);
      
    // } else {
    //   filteredRes = [...postFilterType, item?.id]
    // }
    // saveFilterTypeSelection(filteredRes);

    if (item?.id === filterByTypeDataIds.ALL) {
      const allTypeIds = filterByTypeData.filter(type => type.id !== filterByTypeDataIds.ALL).map(type => type.id);
      const isAllSelected = allTypeIds.every(id => postFilterType.includes(id));

      if (isAllSelected) {
        saveFilterTypeSelection([]);
      } else {
        saveFilterTypeSelection(allTypeIds);
      }
    } else {
      const currItemId = postFilterType.find((id: string) => id === item?.id);
      if (currItemId) {
        const filteredRes = postFilterType.filter((id: string) => id !== item?.id);
        saveFilterTypeSelection(filteredRes);
      } else {
        saveFilterTypeSelection([...postFilterType, item?.id]);
      }
    }
  };

  const onRemoveCategoryPress = () => {
    saveFilterTypeCategories([])
  }

  const toggleCategoryModal = useCallback(() => {
    setCategoryModal(prev => !prev);
  }, [])

  const onCategorySelection = useCallback((categories: EyengageFilterCategory[]) => {
    saveFilterTypeCategories(categories)
    toggleCategoryModal();
  }, [])

  const renderFilterByTypeCard = ({ item }: any) => {
    let isSelected = false
    if (item?.id === filterByTypeDataIds.ALL) {
      const allTypeIds = filterByTypeData.filter(type => type.id !== filterByTypeDataIds.ALL).map(type => type.id);
      isSelected = allTypeIds.every(id => postFilterType.includes(id));
    } else {
      isSelected = postFilterType.includes(item?.id);
    }

    return (
      <div className='mg-t-8'>
        <CustomCheckbox 
          label={item?.name} 
          isChecked={isSelected} 
          onChange={() => handleItemPress(item)} 
        />
      </div>
    );
  };

  const onResetFilterPress = () => {
    saveFilterTypeSelection([]);
    saveFilterTypeCategories([])
  }

  const formatSelectedCategoryNames = useMemo((): any => {
    const count = postFilterCategories.length;
    if (count === 0) {
      return "";
    }
    if (count === 1) {
      return postFilterCategories[0].text;
    }
    if (count === 2) {
      return `${postFilterCategories[0].text}, ${postFilterCategories[1].text}`;
    }
    const remainingCount = count - 2;
    return (
      <>
        {postFilterCategories[0].text}, {postFilterCategories[1].text} <span className="more-text-tag fw-semibold"> + {remainingCount} more</span>
      </>
    )
  }, [postFilterCategories]);

  return (
    <>
      <div className='d-flex justify-content-between align-items-center w-100 border-bottom border-gray-600 pd-b-15 mg-b-15'>
        <p className='fs-16 fw-semibold text-black mb-0'>Filters</p>
        <CustomButton
          text="Reset"
          color="link"
          onClick={onResetFilterPress}
          customBtnStyle='custom-btn-link-with-underline'
        />
      </div>
      <div className='mg-b-30'>
        <div className='fs-14 fw-semibold text-black mg-b-10'>Category:</div>
        <div className='position-relative'>
          <CustomButton 
            text={<span className='category-text'>{formatSelectedCategoryNames || "Select"}</span>} 
            color="outline-primary" 
            onClick={toggleCategoryModal} 
            customBtnStyle='btn-category' 
            customBtnInnerStyle='d-block text-start'
          />
          <div className='category-action-list'>
            {formatSelectedCategoryNames ?
              <CustomButton
                icon={<IoCloseOutline size={16} />}
                color="link"
                onClick={onRemoveCategoryPress}
                customBtnStyle='custom-btn-link'
              /> : null
            }
            <CustomButton 
              icon={<FaCaretDown size={16} />}
              color="link" 
              onClick={() => {}} 
              customBtnStyle='custom-btn-link' 
            />
          </div>
        </div>
      </div>
      
      <div className='d-flex align-items-center justify-content-between'>
        <div className='fs-14 fw-semibold text-black mg-b-10'>
          Type:
        </div>
      </div>
      {
        filterByTypeData.map(item => (
          <div>{
            renderFilterByTypeCard({ item })
          }</div>
        ))
      }
      <EyengagePostCategoryListModal
        isOpen={categoryModal}
        toggleCategoryModal={toggleCategoryModal}
        selectedCategoriesArray={postFilterCategories}
        onCategorySelection={onCategorySelection}
      />
    </>
  );
};

export default EngageFilterBody;
